export default "__VITE_ASSET__aPu$CFP9__"